module.exports = __webpack_public_path__ + "static/media/nortification_list_current.6f0ebd08.svg";